/**
 * Formats a number with comma thousands separators for display in text inputs.
 *
 * Uses en-US locale for consistent comma formatting (e.g. 8157162 → "8,157,162").
 * No currency symbol — just commas for readability.
 * @module utils/formatNumberWithCommas
 */

/**
 * Formats a number with comma thousands separators
 * @param value - The numeric value to format
 * @returns Formatted string with commas (e.g. "8,157,162")
 */
export default function formatNumberWithCommas(value: number): string {
  return value.toLocaleString("en-US", { maximumFractionDigits: 0 });
}
